import { withServerProps } from '@web/library/with-server-props';
import { Page } from '@web/components/page';
import { ShowFaqTagScreen, ShowFaqTagScreenProps } from 'shared/screens/blog/show-faq-tag';

export default function HelpTag(props: ShowFaqTagScreenProps) {
  return (
    <Page
      {...props}
      register={(seo) => seo.setTitle(props.tag.name).setDescription(props.tag.description)}
    >
      <ShowFaqTagScreen {...props} />
    </Page>
  );
}

export const getServerSideProps = withServerProps(ShowFaqTagScreen.pageBuilder);
